import { TButtonSize } from '@core/types/button';

export interface ISideIcon {
  name: string;
  size: number;
}

export interface IButtonIcon {
  name: string;
  position: string;
  transform?: string;
}

export interface IButton {
  text: string;
  appearance?: string;
  icon?: IButtonIcon;
  link?: string;
  rel?: string;
  sideIcon?: ISideIcon;
  size?: TButtonSize;
  staticLink?: string;
  targetMethod?: string;
}

export interface IButtonConfig {
  breakpoint: EnButtonBreakpoint | EnButtonBreakpoint[] | undefined;
  reSize: TButtonSize;
}

export enum EnButtonBreakpoint {
  desktopLarge = 'desktopLarge',
  desktopMedium = 'desktopMedium',
  desktopSmall = 'desktopSmall',
  tablet = 'tablet',
  mobile = 'mobile',
  mobileLarge = 'mobileLarge',
}
